module.exports = __webpack_public_path__ + "img/shoes.99c11db3.jpeg";